import { mapActions } from 'vuex';

import { useThrottle, wrapToLoadingFn } from '@helpers';

import { PrintProvidersApiService } from '../../_services/printProviders.api.service';

export default {
  name: 'PrintProviderSettingsEditor',

  model: {
    type: 'input',
    prop: 'value',
  },

  props: {
    value: Boolean,
    create: Boolean,
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      vendor: '',
      settingsCode: '',

      availableOperations: [],
      availableOperationsLoading: false,
      availableOperationsGetterDelay: () => {},
    };
  },

  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    title() {
      return this.create
        ? 'Create print provider settings'
        : `Edit settings: ${this.settings.vendor}`;
    },
    isInvalidForm() {
      return !this.vendor || !this.checkSettingsValidity();
    },
  },

  watch: {
    value() {
      if (this.create) {
        return;
      }
      this.vendor = this.settings.vendor;
      this.settingsCode = this.settings.settings
        ? JSON.stringify(JSON.parse(this.settings.settings), null, '\t')
        : '';
    },

    vendor: {
      handler(vendor) {
        if (vendor) {
          this.availableOperationsGetterDelay({ vendor });
        }
      },
      immediate: true,
    },
  },

  created() {
    this.availableOperationsGetterDelay = useThrottle(this.getAvailableOperations, 200);
  },

  methods: {
    ...mapActions('printProviders', ['updatePlugin']),

    submitSettings() {
      if (this.isInvalidForm) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: `${this.create ? 'Create' : 'Update'} settings?`,
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await this.updatePlugin({
            vendor: this.create ? this.vendor : this.settings.vendor,
            settings: JSON.parse(this.settingsCode),
          });
          this.$VBlackerTheme.notification.warning('Warning! Please note that changes will be applied only after site and service restart. Please contact IT support for that.');
          this.$emit('success');
          this.dialog = false;
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },

    checkSettingsValidity() {
      if (!this.settingsCode.trim()) {
        return false;
      }
      try {
        JSON.parse(this.settingsCode);
        return true;
      } catch (e) {
        return false;
      }
    },

    getAvailableOperations({ vendor }) {
      this.wrapToLoadingFn({
        req: PrintProvidersApiService.getAvailableOperations.bind({}, {
          suffix: this.suffix,
          vendor,
        }),
        loadingFlagName: 'availableOperationsLoading',
        onSuccess: (r) => {
          this.availableOperations = r;
        },
      });
    },

    onModalClose() {
      this.vendor = '';
      this.settingsCode = '';
      this.$emit('update:create', true);
    },

    wrapToLoadingFn,
  },
};
